import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class GenieEventFilter extends Component {
    state = {
        genieEventLists:[],
        genieEventValue: '',
        isgenieEventLoading: true
    };
    componentDidMount(){
        this.getgenieEvent();
    }
    restgenieEventFilter() {
        this.setState({
            genieEventValue: [],
        })
    }
    getgenieEvent(){
        axios.get(config.get('API_URL')+'/filters/get-genie-events-filters/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((event_name, index) => {
                    this.state.genieEventLists.push({value: event_name.event_name, label: event_name.event_name})
                });
            }
            this.setState({
                isgenieEventLoading: false
            })
        });

    }


    changegenieEvent(optionSelected){
        let value='';
        let tenderArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenderArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                tenderArray.push(ids.value)
                var index = this.state.genieEventLists.findIndex(obj => obj.value==ids.value);
                this.state.genieEventLists.move(index,0).join(',');
            });
        }
        this.props.onSelectgenieEvent(optionSelected, tenderArray);
        this.setState({
            genieEventValue:optionSelected,
        });

    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="event_name"
                isMulti
                value={this.state.genieEventValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changegenieEvent.bind(this)}
                options={this.state.genieEventLists}
                placeholderButtonLabel="Select [Event Name]"
                isLoading={this.state.isgenieEventLoading}
            />
        );

    }
}
export default GenieEventFilter;